import dimensionsJson from '../dimensions.json';
import { MessagesCategoryType } from '../models';
import { MetricsFeatures } from 'modules/metrics/MetricsFeatures';
const dimensions = dimensionsJson;
export class MessageAnalyticsService {
    static $inject = ['MetricsService', 'StatisticsService2', '$translate', 'MessagingHubService'];
    constructor(MetricsService, StatisticsService2, $translate, MessagingHubService) {
        'ngInject';
        this.MetricsService = MetricsService;
        this.StatisticsService2 = StatisticsService2;
        this.$translate = $translate;
        this.MessagingHubService = MessagingHubService;
    }
    getCategories() {
        const categoryKeys = Object.keys(dimensions.messages);
        const categories = [];
        categoryKeys.forEach((c) => {
            const value = this.$translate.instant(`reports.categories.${c}`);
            categories.push({ key: c, value: value });
        });
        return categories;
    }
    async getActionsForCategory({ category, endDate, startDate, application, }) {
        let result;
        switch (category) {
            case MessagesCategoryType.SentMessages:
                result = await this.getActionsSentMessages({
                    shortName: application.shortName,
                    startDate,
                    endDate,
                });
                break;
            case MessagesCategoryType.ReceivedMessages:
                result = await this.getActionsReceivedMessages({
                    shortName: application.shortName,
                    startDate,
                    endDate,
                });
                break;
            case MessagesCategoryType.TotalMessages:
                result = await this.getActionsTotalMessages({
                    shortName: application.shortName,
                    startDate,
                    endDate,
                });
                break;
            case MessagesCategoryType.ActiveMessages:
                result = await this.getActiveMessages({
                    startDate,
                    endDate,
                    application,
                });
                break;
            case MessagesCategoryType.ActiveMessagesPerDomain:
                result = await this.getActiveMessagesPerDomain({
                    startDate,
                    endDate,
                    application,
                });
                break;
        }
        return result.map((element) => ({
            category,
            action: category,
            ...element,
        }));
    }
    async getActionsSentMessages(payload) {
        const { startDate, endDate } = payload;
        const enableFT = await MetricsFeatures.isEnableMetricsToStatistics();
        if (enableFT) {
            const { items } = await this.MetricsService.getSentMessagesStatistics(this.StatisticsService2.INTERVAL_DAILY, startDate, endDate);
            return this.returnItems(items);
        }
        else {
            const { items } = await this.StatisticsService2.getMessagesStatistics(this.MetricsService.INTERVAL_DAILY, this.StatisticsService2.AGGREGATION_TYPE_SENT_BY, startDate, endDate);
            return this.returnItems(items);
        }
    }
    returnItems(items) {
        return items.map((day) => ({
            ...day,
            count: day.count,
            storageDate: new Date(day.intervalStart).toJSON(),
        }));
    }
    async getActionsReceivedMessages(payload) {
        const { startDate, endDate } = payload;
        const enableFT = await MetricsFeatures.isEnableMetricsToStatistics();
        if (enableFT) {
            const { items } = await this.MetricsService.getReceivedMessagesStatistics(this.MetricsService.INTERVAL_DAILY, startDate, endDate);
            return this.returnItems(items);
        }
        else {
            const { items } = await this.StatisticsService2.getMessagesStatistics(this.StatisticsService2.INTERVAL_DAILY, this.StatisticsService2.AGGREGATION_TYPE_RECEIVED_BY, startDate, endDate);
            return this.returnItems(items);
        }
    }
    async getActionsTotalMessages(payload) {
        const [received, sent] = await Promise.all([
            this.getActionsReceivedMessages(payload),
            this.getActionsSentMessages(payload),
        ]);
        const receivedEvents = received.map((day) => ({
            action: 'receivedMessages',
            count: day.count,
            storageDate: day.storageDate,
        }));
        const sentEvents = sent.map((day) => ({
            action: 'sentMessages',
            count: day.count,
            storageDate: day.storageDate,
        }));
        return receivedEvents.concat(sentEvents);
    }
    async getActiveMessages(payload) {
        const { startDate, endDate } = payload;
        const { items } = await this.MessagingHubService.sendCommand({
            method: 'get',
            to: 'postmaster@analytics.msging.net',
            uri: `/metrics/active-messages/NI?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
        });
        return [
            {
                count: items[0].count,
                action: MessagesCategoryType.ActiveMessages,
            },
        ];
    }
    async getActiveMessagesPerDomain(payload) {
        const { startDate, endDate } = payload;
        const { resource: { items } } = await this.MessagingHubService.processCommand({
            method: 'get',
            to: 'postmaster@analytics.msging.net',
            uri: `/metrics/active-messages-per-domain/NI?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
        });
        return [
            {
                action: MessagesCategoryType.ActiveMessagesPerDomain,
                itemsPerDomain: items,
            },
        ];
    }
}
MessageAnalyticsService.$inject = ['MetricsService', 'StatisticsService2', '$translate', 'MessagingHubService'];
